import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { HighlightedProps, SchoolReportType } from '../../types';
import { SectionLayout, getFilteredAverage, getOthersAverage } from '../modules';
import { StudentProgress } from '../../../components';
import type { ChartDataType, ChartIconType } from '../../../components/charts/types';

type Props = {
  schoolReport: SchoolReportType;
  showOthersData: boolean;
  iconToUse: ChartIconType
} & HighlightedProps;

const SchoolProgressions = ({ schoolReport, showOthersData, highlightedLabel, highlightedIds, iconToUse, onElementClick }: Props): JSX.Element => {
  const { translate } = useI18n();
  const value = (schoolReport.average.progressionAverage ?? 0).toFixed(2);

  const dataToUse = (): ChartDataType[] => {
    if (iconToUse === 'class') {
      return schoolReport.classes;
    } else return schoolReport.yearGroups;
  };
  const highlightedAverage = getFilteredAverage(dataToUse(), highlightedIds, (group) => group.chartsData?.progression);
  const othersAverage = showOthersData ? getOthersAverage(dataToUse(), highlightedIds, (group) => group.chartsData?.progression) : null;

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.title')}
      value={value}
      highlightLabel={highlightedLabel}
      highlightValue={highlightedAverage != null ? highlightedAverage.toFixed(2) : null}
      othersLabel={showOthersData && highlightedIds.length > 0 ? translate('pages.REPORTS.HEADERS.OTHERS') : null}
      othersValue={othersAverage != null ? othersAverage.toFixed(2) : null}
      description={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.description')}
      moreInfo={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.info')}
      id={'school-progressions-container'}
    >
      <StudentProgress
        showOthersData={showOthersData}
        data={dataToUse()}
        chartType={'progression'}
        type={iconToUse}
        highlightedIds={highlightedIds}
        onElementClick={onElementClick}
      />
    </SectionLayout>
  );
};

SchoolProgressions.displayName = 'SchoolProgressions';

export default SchoolProgressions;
